import {Component} from 'substance'
import {KBDKeyComboComponent} from './KBDKeyComboComponent'

// Alt, ctrl, cmd, and some other keys generate char codes that we want to ignore
// This is only for display purposes and does not affect the keybinding
const ignoredCharCodes = [16, 17, 18, 91, 93]

/**
 * To remain compatible with substance KeyboardManager and NPKeyboardManager
 * this component will only capture combinations in the form of:
 * [ALT]+[ALTGR]+[CMD]+[CTRL]+[SHIFT]+[key]
 * Note that only one 'normal' key will be captured.
 */
class KeybindingCaptureComponent extends Component {

    didMount() {
        this._boundHandleKeyDown = this._handleKeyDown.bind(this)
        document.addEventListener('keydown', this._boundHandleKeyDown, true)
    }

    dispose() {
        document.removeEventListener('keydown', this._boundHandleKeyDown, true)
    }

    _handleKeyDown(e) {
        const {npKeyboardManager} = this.context.configurator
        const generatedKey = npKeyboardManager.generateKey(e)

        e.preventDefault()
        e.stopPropagation()

        switch (generatedKey) {
            case '27':
                this.cancel()
                break
            case '13':
                this.save()
                break
            default:
                this.extendState({ keyCombo: this.parseCombo(generatedKey) })
        }
    }

    getInitialState() {
        return {
            keyCombo: this.props.keyCombo ? this.props.keyCombo : null
        }
    }

    render($$) {
        return $$('div', {class: 'keybinding-capture-container'}, [
            $$('h2', {class: 'keybinding-capture-description'},
                this.props.description
            ),
            $$('h3', {class: 'keybinding-capture-message'},
                this.getLabel('keybinding-modify-keyboard-shortcuts-message')
            ),
            $$(KBDKeyComboComponent, {keyCombo: this.state.keyCombo})
        ])
    }

    save() {
        // TODO: Actually save the key bindings
        console.info('Saving combo:', this.state.keyCombo)
        this.props.onSave(this.state.keyCombo)
    }

    cancel() {
        console.info('Canceling')
        this.props.onCancel()
    }

    parseCombo(combo) {
        let parsedFrags = []
        let frags = combo.split('+')
        for (var i = 0; i < frags.length; i++) {
            let frag = frags[i].toUpperCase()
            let charCode = parseInt(frag, 10)
            if (charCode && !ignoredCharCodes.includes(charCode)) {
                parsedFrags.push(String.fromCharCode(charCode))
            } else if (!charCode) {
                parsedFrags.push(frag)
            }
        }
        return parsedFrags.join('+')
    }
}

export {KeybindingCaptureComponent}
